import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from '../blocks';

const Svg = styled.svg`
    width: 16px;
    height: 16px;
    color: blue;
`;

export const StatusInProgress = () => {
    const { t } = useTranslation('common');
    return (
        <Svg width={'16px'} height={'16px'} aria-label={t('icon-statusInProgressLabel')}>
            <g id={'icon'}>
                <g>
                    <circle fill={'none'} stroke={'currentColor'} strokeWidth={'2px'} cx={'8'} cy={'8'} r={'7'} />
                    <rect
                        fill={'none'}
                        stroke={'currentColor'}
                        strokeWidth={'2px'}
                        x={'4.99'}
                        y={'7.995'}
                        width={'0.01'}
                        height={'0.01'}
                    />
                    <rect
                        fill={'none'}
                        stroke={'currentColor'}
                        strokeWidth={'2px'}
                        x={'7.99'}
                        y={'7.995'}
                        width={'0.01'}
                        height={'0.01'}
                    />
                    <rect
                        fill={'none'}
                        stroke={'currentColor'}
                        strokeWidth={'2px'}
                        x={'10.99'}
                        y={'7.995'}
                        width={'0.01'}
                        height={'0.01'}
                    />
                </g>
            </g>
        </Svg>
    );
};
